import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    corporate_loading: false,
    corporate_dropdown_data: null,
    corporate_kyc_data: null,
    corporate_save_loading: false,
    rejection_summary: null,
    is_rejected: false,
    field_codes: null,
    field_codes_loading: false,
    upload_loading: false,
    is_qualified: false,
    delete_draft_kyc_loading: false,
};

export const corporateSlice = createSlice({
    name: 'corporate',
    initialState,

    reducers: {
        setCorporateLoading: (state, action) => {
            state.corporate_loading = action.payload;
        },
        setCorporateDropdownData: (state, action) => {
            state.corporate_dropdown_data = action.payload;
        },
        setCorporateKycData: (state, action) => {
            state.corporate_kyc_data = action.payload;
        },
        setCorporateSaveLoading: (state, action) => {
            state.corporate_save_loading = action.payload;
        },
        setRejectionSummary: (state, action) => {
            state.rejection_summary = action.payload;
        },
        setIsRejected: (state, action) => {
            state.is_rejected = action.payload;
        },
        setFieldCodes: (state, action) => {
            state.field_codes = action.payload;
        },
        setFieldCodesLoading: (state, action) => {
            state.field_codes_loading = action.payload;
        },
        setUploadLoading: (state, action) => {
            state.upload_loading = action.payload;
        },
        setIsQualified: (state, action) => {
            state.is_qualified = action.payload;
        },
        setDeleteDraftKycLoading: (state, action) => {
            state.delete_draft_kyc_loading = action.payload;
        },
    },
});

export const {
    setCorporateLoading,
    setCorporateDropdownData,
    setCorporateKycData,
    setCorporateSaveLoading,
    setRejectionSummary,
    setIsRejected,
    setFieldCodes,
    setFieldCodesLoading,
    setUploadLoading,
    setIsQualified,
    setDeleteDraftKycLoading,
} = corporateSlice.actions;
export default corporateSlice.reducer;